//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"CosimSampleTimeExpression",0,"Expression",0],[0,"CosimSimModel",1,0],[1,"DynamicErrorToleranceExpression",0,"Expression",0],[1,"DynamicInitialStepSizeExpression",0,"Expression",0],[0,"DynamicMaxKinIteration",1,0],[1,"DynamicMaxStepSizeExpression",0,"Expression",0],[1,"DynamicNumericalDampingExpression",0,"Expression",0],[1,"RedundantViolationToleranceForAngleExpression",0,"Expression",0],[1,"RedundantViolationToleranceForLengthExpression",0,"Expression",0],[1,"StaticErrorToleranceExpression",0,"Expression",0],[1,"StaticInitialStepSizeExpression",0,"Expression",0],[0,"StaticIntegratorType",1,0],[0,"StaticMaxIteration",1,0],[1,"StaticMaxStepSizeExpression",0,"Expression",0],[1,"StaticStabilityExpression",0,"Expression",0]],[],[]];
SPLM.Motion.RecurdynSolverProperty = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.RecurdynSolverProperty";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.RecurdynSolverProperty.StaticIntegratorTypes = Object.freeze({
    "NewtonRapson" : "NewtonRapson", "RobustNewtonRapson" : "RobustNewtonRapson"});

export default SPLM;